(function() { module.exports = this["wp"]["blob"]; }());